import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import Colors from '../resource/ResourceColors.jsx';

import UtilIcon from '../util/UtilIcon.jsx';
import UtilControl from '../util/UtilControl.jsx';

const FormField = styled.div`
    position: absolute;
    z-Index: 100;
    padding-top: 8%;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${Colors.alpha(40)};
`;

const FormContainer = styled.div`
    margin: auto;
    overflow: auto;
    border-radius: 0.25rem;
    width: 50%;    
    background: ${Colors.grey(100)};
    box-shadow: ${Colors.extra_wide_raw_shadow(50)};
`;

const FormHeader = styled.div`
    padding: 0.25rem 0.25rem 0.25rem 1rem;        
    height: 1.4rem;
    border-bottom: 0.15rem solid ${Colors.primary(90)};
    box-shadow: ${Colors.wide_raw_shadow(8)};
    background: ${Colors.right_diagonal_gradient(99, 92)};
`;

const FormTitle = styled.div`
    float: left;
    font-size: 1.35rem;
    color: ${Colors.primary(50)};
    text-shadow: ${Colors.tight_text_shadow(20)};
`;

const FormClose = styled.div`
    float: right;
    display: inline-block;
    filter: ${Colors.tight_shadow(30)};   
`;

const FormContent = styled.div`
    min-height: 5rem;
    padding: 0.35rem 1rem;
    color: ${Colors.primary(40)}
`;

const FormFooter = styled.div`
    padding: 0.15rem;    
    height: 1.6rem;
    border-top: 0.15rem solid ${Colors.primary(80)};
    box-shadow: ${Colors.wide_raw_shadow(10, true)};
    background: ${Colors.right_diagonal_gradient(90, 80)};
`;

export class UtilForm extends Component {

    static propTypes = {
        handler: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        width: PropTypes.string.isRequired,
        contents: PropTypes.object.isRequired,
    }

    render() {
        const container_style = {
            width: this.props.width
        }
        const ok_button = <UtilControl
            id={'button-ok'}
            type={'button'}
            label={'OK'}
            handler={(e) => this.props.handler('rhapsody-2020-10.mid')}
        />;
        const cancel_button = <UtilControl
            id={'button-cancel'}
            type={'button'}
            label={'Cancel'}
            handler={(e) => this.props.handler(null)}
        />;
        return <FormField>
            <FormContainer style={container_style}>
                <FormHeader>
                    <FormTitle>{this.props.title}</FormTitle>
                    <FormClose>
                        <UtilIcon
                            hover
                            color={Colors.primary(50)}
                            hover_min={0.25}
                            icon="times-circle"
                            absSize={'1.2rem'}
                            id={'form-close'}/>
                    </FormClose>
                </FormHeader>
                <FormContent>
                    {this.props.contents}
                </FormContent>
                <FormFooter>
                    {ok_button}
                    {cancel_button}
                </FormFooter>
            </FormContainer>
        </FormField>
    }
}

export default UtilForm;